import { render } from "./as-spinner.vue?vue&type=template&id=39d5c95a&scoped=true&ts=true"
import script from "./as-spinner.vue?vue&type=script&lang=ts"
export * from "./as-spinner.vue?vue&type=script&lang=ts"

import "./as-spinner.vue?vue&type=style&index=0&id=39d5c95a&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d5c95a"]])

export default __exports__